// src/pages/About/OurService.jsx
import React from 'react';
import Header from '../../components/common/Header/Header';
import Footer from '../../components/common/Footer/Footer';
import Layout from '../../components/common/Layout/Layout';

const KycPage = () => {
    const styles = {
        pageContainer: {
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: '#f8f9fa'
        },
        // KYC Header Section (similar to video tutorial header)
        kycHeader: {
            background: '#1a2332',
            backgroundImage: `
                radial-gradient(circle at 25% 25%, rgba(255,255,255,0.1) 1px, transparent 1px),
                radial-gradient(circle at 75% 75%, rgba(255,255,255,0.05) 1px, transparent 1px)
            `,
            backgroundSize: '20px 20px, 30px 30px',
            padding: '2rem 0',
            marginBottom: '0',
            position: 'relative',
            overflow: 'hidden',
            borderBottom: '1px solid rgba(255,255,255,0.1)'
        },
        kycHeaderContent: {
            maxWidth: '1400px',
            margin: '0 auto',
            padding: '0 2rem',
            position: 'relative',
            zIndex: 2
        },
        kycTitle: {
            fontSize: '2rem',
            fontWeight: '600',
            color: '#ffffff',
            margin: '0',
            textAlign: 'center',
            textShadow: '0 1px 2px rgba(0,0,0,0.1)'
        },
        // Main Content Section
        mainContent: {
            flex: 1,
            padding: '3rem 0',
            backgroundColor: '#ffffff'
        },
        container: {
            maxWidth: '1200px',
            margin: '0 auto',
            padding: '0 2rem'
        },
        // Info Section
        infoSection: {
            backgroundColor: '#f8f9fa',
            padding: '2rem',
            borderRadius: '8px',
            marginBottom: '3rem',
            border: '1px solid #e9ecef'
        },
        infoText: {
            fontSize: '0.95rem',
            color: '#495057',
            lineHeight: '1.6',
            margin: '0',
            textAlign: 'justify'
        },
        // Two Column Layout
        twoColumnLayout: {
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '3rem',
            marginBottom: '3rem'
        },
        // Section Cards
        sectionCard: {
            backgroundColor: '#ffffff',
            padding: '2rem',
            borderRadius: '8px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            border: '1px solid #e9ecef'
        },
        sectionTitle: {
            fontSize: '1.3rem',
            fontWeight: '600',
            color: '#1a2332',
            marginBottom: '1.5rem',
            textAlign: 'center'
        },
        // KYC Provider Links
        kycProviderList: {
            display: 'flex',
            flexDirection: 'column',
            gap: '1rem'
        },
        kycProviderItem: {
            display: 'flex',
            alignItems: 'center',
            padding: '0.75rem 1rem',
            backgroundColor: '#f8f9fa',
            borderRadius: '6px',
            border: '1px solid #e9ecef',
            textDecoration: 'none',
            color: '#495057',
            transition: 'all 0.2s ease',
            cursor: 'pointer'
        },
        kycProviderLogo: {
            width: '100px',
            height: '30px',
            marginRight: '1rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '0.9rem',
            fontWeight: '600'
        },
        kycProviderText: {
            fontSize: '0.9rem',
            color: '#6c757d'
        },
        // Download Forms Section
        downloadSection: {
            backgroundColor: '#ffffff',
            padding: '2rem',
            borderRadius: '8px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            border: '1px solid #e9ecef'
        },
        downloadTitle: {
            fontSize: '1.3rem',
            fontWeight: '600',
            color: '#1a2332',
            marginBottom: '1.5rem',
            textAlign: 'center'
        },
        downloadList: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75rem'
        },
        downloadItem: {
            display: 'flex',
            alignItems: 'center',
            padding: '0.75rem 1rem',
            backgroundColor: '#f8f9fa',
            borderRadius: '6px',
            border: '1px solid #e9ecef',
            textDecoration: 'none',
            color: '#495057',
            transition: 'all 0.2s ease',
            cursor: 'pointer'
        },
        downloadLogo: {
            width: '80px',
            height: '25px',
            marginRight: '1rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '0.8rem',
            fontWeight: '600'
        },
        downloadText: {
            fontSize: '0.9rem',
            color: '#6c757d'
        }
    };

    return (
        <>
            <style>{`
                .kyc-provider-item:hover,
                .download-item:hover {
                    background-color: #e9ecef;
                    border-color: #dee2e6;
                    transform: translateY(-1px);
                }

                .cdsl-logo {
                    background: linear-gradient(135deg, #4a90e2, #357abd);
                    color: white;
                    border-radius: 4px;
                }

                .nsdl-logo {
                    background: linear-gradient(135deg, #ff6b35, #e55a2b);
                    color: white;
                    border-radius: 4px;
                }

                .cams-logo {
                    background: linear-gradient(135deg, #00a8cc, #0077a3);
                    color: white;
                    border-radius: 4px;
                }

                .nse-logo {
                    background: linear-gradient(135deg, #1e3a8a, #1e40af);
                    color: white;
                    border-radius: 4px;
                }

                .karvy-logo {
                    background: linear-gradient(135deg, #0ea5e9, #0284c7);
                    color: white;
                    border-radius: 4px;
                }

                .kfintech-logo {
                    background: linear-gradient(135deg, #059669, #047857);
                    color: white;
                    border-radius: 4px;
                }

                @media (max-width: 768px) {
                    .two-column-layout {
                        grid-template-columns: 1fr !important;
                        gap: 2rem !important;
                    }
                    
                    .kyc-title {
                        font-size: 1.5rem !important;
                    }
                    
                    .container {
                        padding: 0 1rem !important;
                    }
                    
                    .section-card,
                    .download-section,
                    .info-section {
                        padding: 1.5rem !important;
                    }
                }

                @media (max-width: 640px) {
                    .kyc-header {
                        padding: 1.5rem 0 !important;
                    }
                    
                    .main-content {
                        padding: 2rem 0 !important;
                    }
                    
                    .kyc-title {
                        font-size: 1.3rem !important;
                    }
                    
                    .section-title,
                    .download-title {
                        font-size: 1.1rem !important;
                    }
                    
                    .kyc-provider-logo,
                    .download-logo {
                        width: 70px !important;
                        height: 20px !important;
                        font-size: 0.7rem !important;
                    }
                }
            `}</style>

            <div style={styles.pageContainer}>
                {/* Header */}
                <Header />

                {/* KYC Header Section */}
                <section style={styles.kycHeader}>
                    <div style={styles.kycHeaderContent}>
                        <h1 style={styles.kycTitle} className="kyc-title">
                            KYC
                        </h1>
                    </div>
                </section>

                {/* Main Content */}
                <main style={styles.mainContent}>
                    <div style={styles.container} className="container">
                        {/* Info Section */}
                        <div style={styles.infoSection} className="info-section">
                            <p style={styles.infoText}>
                                In order to comply with regulatory provisions under the Prevention of Money Laundering Act 2002, issued by SEBI/ Govt. of India, KYC/ AADHAAR / FATCA formalities are required to be completed for all Unit Holders, including Guardians and Power of Attorney holders, for any investment in mutual funds.
                            </p>
                        </div>

                        {/* Two Column Layout */}
                        <div style={styles.twoColumnLayout} className="two-column-layout">
                            {/* Check KYC Status */}
                            <div style={styles.sectionCard} className="section-card">
                                <h2 style={styles.sectionTitle} className="section-title">Check your KYC status</h2>
                                <div style={styles.kycProviderList}>
                                    <a 
                                        href="https://www.cvlkra.com/" 
                                        target="_blank" 
                                        rel="noopener noreferrer"
                                        style={styles.kycProviderItem} 
                                        className="kyc-provider-item"
                                    >
                                        <div style={{...styles.kycProviderLogo, ...{background: 'linear-gradient(135deg, #4a90e2, #357abd)', color: 'white', borderRadius: '4px'}}} className="cdsl-logo">
                                            CDSL
                                        </div>
                                        <span style={styles.kycProviderText}>CVLKRA</span>
                                    </a>
                                    <a 
                                        href="https://kra.ndml.in/kra-web/jsps/pos/KYCClientInquiry_NEW.jsp" 
                                        target="_blank" 
                                        rel="noopener noreferrer"
                                        style={styles.kycProviderItem} 
                                        className="kyc-provider-item"
                                    >
                                        <div style={{...styles.kycProviderLogo, ...{background: 'linear-gradient(135deg, #ff6b35, #e55a2b)', color: 'white', borderRadius: '4px'}}} className="nsdl-logo">
                                            NSDL
                                        </div>
                                        <span style={styles.kycProviderText}>NSDL KRA</span>
                                    </a>
                                    <a 
                                        href="https://www.camskra.com" 
                                        target="_blank" 
                                        rel="noopener noreferrer"
                                        style={styles.kycProviderItem} 
                                        className="kyc-provider-item"
                                    >
                                        <div style={{...styles.kycProviderLogo, ...{background: 'linear-gradient(135deg, #00a8cc, #0077a3)', color: 'white', borderRadius: '4px'}}} className="cams-logo">
                                            CAMS
                                        </div>
                                        <span style={styles.kycProviderText}>CAMS KRA</span>
                                    </a>
                                    <a 
                                        href="https://www.nsekra.com" 
                                        target="_blank" 
                                        rel="noopener noreferrer"
                                        style={styles.kycProviderItem} 
                                        className="kyc-provider-item"
                                    >
                                        <div style={{...styles.kycProviderLogo, ...{background: 'linear-gradient(135deg, #1e3a8a, #1e40af)', color: 'white', borderRadius: '4px'}}} className="nse-logo">
                                            NSE
                                        </div>
                                        <span style={styles.kycProviderText}>NSE KRA</span>
                                    </a>
                                    <a 
                                        href="https://www.karvykra.com/index.aspx?ReturnUrl=%2f" 
                                        target="_blank" 
                                        rel="noopener noreferrer"
                                        style={styles.kycProviderItem} 
                                        className="kyc-provider-item"
                                    >
                                        <div style={{...styles.kycProviderLogo, ...{background: 'linear-gradient(135deg, #0ea5e9, #0284c7)', color: 'white', borderRadius: '4px'}}} className="karvy-logo">
                                            KARVY
                                        </div>
                                        <span style={styles.kycProviderText}>KARVY KRA</span>
                                    </a>
                                </div>
                            </div>

                            {/* Validate KYC */}
                            <div style={styles.sectionCard} className="section-card">
                                <h2 style={styles.sectionTitle} className="section-title">Validate your KYC</h2>
                                <div style={styles.kycProviderList}>
                                    <a 
                                        href="https://validate.cvlindia.com/CVLKRAVerification_V1/" 
                                        target="_blank" 
                                        rel="noopener noreferrer"
                                        style={styles.kycProviderItem} 
                                        className="kyc-provider-item"
                                    >
                                        <div style={{...styles.kycProviderLogo, ...{background: 'linear-gradient(135deg, #4a90e2, #357abd)', color: 'white', borderRadius: '4px'}}} className="cdsl-logo">
                                            CDSL
                                        </div>
                                        <span style={styles.kycProviderText}>CVLKRA</span>
                                    </a>
                                    <a 
                                        href="https://kra.ndml.in/ClientInitiatedKYC-webApp/#/ClientinitiatedKYC" 
                                        target="_blank" 
                                        rel="noopener noreferrer"
                                        style={styles.kycProviderItem} 
                                        className="kyc-provider-item"
                                    >
                                        <div style={{...styles.kycProviderLogo, ...{background: 'linear-gradient(135deg, #ff6b35, #e55a2b)', color: 'white', borderRadius: '4px'}}} className="nsdl-logo">
                                            NSDL
                                        </div>
                                        <span style={styles.kycProviderText}>NSDL KRA</span>
                                    </a>
                                    <a 
                                        href="https://www.camskra.com/PanDetailsUpdate.aspx" 
                                        target="_blank" 
                                        rel="noopener noreferrer"
                                        style={styles.kycProviderItem} 
                                        className="kyc-provider-item"
                                    >
                                        <div style={{...styles.kycProviderLogo, ...{background: 'linear-gradient(135deg, #00a8cc, #0077a3)', color: 'white', borderRadius: '4px'}}} className="cams-logo">
                                            CAMS
                                        </div>
                                        <span style={styles.kycProviderText}>CAMS KRA</span>
                                    </a>
                                    <a 
                                        href="https://www.karvykra.com/KYC_Validation/Default.aspx" 
                                        target="_blank" 
                                        rel="noopener noreferrer"
                                        style={styles.kycProviderItem} 
                                        className="kyc-provider-item"
                                    >
                                        <div style={{...styles.kycProviderLogo, ...{background: 'linear-gradient(135deg, #0ea5e9, #0284c7)', color: 'white', borderRadius: '4px'}}} className="karvy-logo">
                                            KARVY
                                        </div>
                                        <span style={styles.kycProviderText}>KARVY KRA</span>
                                    </a>
                                </div>
                            </div>
                        </div>

                        {/* Download Forms Section */}
                        <div style={styles.downloadSection} className="download-section">
                            <h2 style={styles.downloadTitle} className="download-title">Download Forms</h2>
                            <div style={styles.downloadList}>
                                <a 
                                    href="https://resources.investwellonline.com/forms/CAMSKRA_Non_Individual.pdf" 
                                    download="KYC_Non_Individual_CAMS.pdf"
                                    style={styles.downloadItem} 
                                    className="download-item"
                                >
                                    <div style={{...styles.downloadLogo, ...{background: 'linear-gradient(135deg, #00a8cc, #0077a3)', color: 'white', borderRadius: '4px'}}} className="cams-logo">
                                        CAMS
                                    </div>
                                    <span style={styles.downloadText}>KYC Non-Individual</span>
                                </a>
                                <a 
                                    href="https://resources.investwellonline.com/forms/Individual_KYC.pdf" 
                                    download="KYC_Individual_CAMS.pdf"
                                    style={styles.downloadItem} 
                                    className="download-item"
                                >
                                    <div style={{...styles.downloadLogo, ...{background: 'linear-gradient(135deg, #00a8cc, #0077a3)', color: 'white', borderRadius: '4px'}}} className="cams-logo">
                                        CAMS
                                    </div>
                                    <span style={styles.downloadText}>KYC Individual</span>
                                </a>
                                <a 
                                    href="https://resources.investwellonline.com/forms/CAMS_FATCA_Non_Individual.pdf" 
                                    download="FATCA_Non_Individual_CAMS.pdf"
                                    style={styles.downloadItem} 
                                    className="download-item"
                                >
                                    <div style={{...styles.downloadLogo, ...{background: 'linear-gradient(135deg, #00a8cc, #0077a3)', color: 'white', borderRadius: '4px'}}} className="cams-logo">
                                        CAMS
                                    </div>
                                    <span style={styles.downloadText}>FATCA Non Individual</span>
                                </a>
                                <a 
                                    href="https://resources.investwellonline.com/forms/CAMS_FATCA-Individuals.pdf" 
                                    download="FATCA_Individual_CAMS.pdf"
                                    style={styles.downloadItem} 
                                    className="download-item"
                                >
                                    <div style={{...styles.downloadLogo, ...{background: 'linear-gradient(135deg, #00a8cc, #0077a3)', color: 'white', borderRadius: '4px'}}} className="cams-logo">
                                        CAMS
                                    </div>
                                    <span style={styles.downloadText}>FATCA Individual</span>
                                </a>
                                <a 
                                    href="https://resources.investwellonline.com/forms/CAMS_UBO_Declaration_Non_Indvidual.pdf" 
                                    download="UBO_Declaration_Non_Individual_CAMS.pdf"
                                    style={styles.downloadItem} 
                                    className="download-item"
                                >
                                    <div style={{...styles.downloadLogo, ...{background: 'linear-gradient(135deg, #00a8cc, #0077a3)', color: 'white', borderRadius: '4px'}}} className="cams-logo">
                                        CAMS
                                    </div>
                                    <span style={styles.downloadText}>UBO Declaration Non-Individual</span>
                                </a>
                                <a 
                                    href="https://resources.investwellonline.com/forms/KFINTECH_FATCA_CRS_Declaration_form_Individual.pdf" 
                                    download="FATCA_CRS_Declaration_Individual_KFINTECH.pdf"
                                    style={styles.downloadItem} 
                                    className="download-item"
                                >
                                    <div style={{...styles.downloadLogo, ...{background: 'linear-gradient(135deg, #059669, #047857)', color: 'white', borderRadius: '4px'}}} className="kfintech-logo">
                                        KFINTECH
                                    </div>
                                    <span style={styles.downloadText}>FATCA CRS Declaration Form Individual</span>
                                </a>
                                <a 
                                    href="https://resources.investwellonline.com/forms/KFINTECH_FATCA_UBO_NON_INDIVIDUALS.pdf" 
                                    download="FATCA_UBO_Non_Individual_KFINTECH.pdf"
                                    style={styles.downloadItem} 
                                    className="download-item"
                                >
                                    <div style={{...styles.downloadLogo, ...{background: 'linear-gradient(135deg, #059669, #047857)', color: 'white', borderRadius: '4px'}}} className="kfintech-logo">
                                        KFINTECH
                                    </div>
                                    <span style={styles.downloadText}>FATCA UBO Non Individual</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </main>

                {/* Layout */}
                <Layout />

                {/* Footer */}
                <Footer />
            </div>
        </>
    );
};

export default KycPage;